import React from "react";
import { Check, Circle, ExternalLink, Truck } from "lucide-react";
import { formatDate, getShipment, getTrackingUrl } from "./orderViewUtils";
import "./OrderTimeline.css";

export default function OrderTimeline({ order }) {
  const progress = Array.isArray(order.progress) ? order.progress : [];
  const shipment = getShipment(order);
  const trackingUrl = getTrackingUrl(order);
  return <section className="order-progress" aria-label="Order progress">
    <ol className="order-progress__steps">
      {progress.map((step) => <li key={step.key} className={step.completed ? "is-complete" : ""} aria-current={step.current ? "step" : undefined}>
        <span className="order-progress__marker" aria-hidden="true">{step.completed ? <Check size={16} /> : <Circle size={16} />}</span>
        <div><strong>{step.label}</strong><small>{step.at ? formatDate(step.at) : step.current ? "In progress" : step.completed ? "Completed" : "Pending"}</small></div>
      </li>)}
    </ol>
    {order.reconciliationRequired ? <p role="status">Payment received. Your order needs review before dispatch. Please contact support; do not pay again.</p> : null}
    {shipment.carrier || shipment.trackingNumber || trackingUrl ? <div className="order-progress__tracking">
      <Truck size={18} aria-hidden="true" />
      <span>{[shipment.carrier, shipment.trackingNumber].filter(Boolean).join(": ") || "Shipment tracking"}</span>
      {trackingUrl ? <a href={trackingUrl} target="_blank" rel="noopener noreferrer"><ExternalLink size={16} aria-hidden="true" /> Track shipment</a> : null}
    </div> : null}
  </section>;
}
